import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';

interface Option {
  id: number;
  name: string;
  isChecked?: boolean;
}

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss']
})
export class SearchDropdownComponent implements OnInit, AfterViewInit {
  @Input() options: Option[] = [];
  @Input() multiSelect: boolean = false;
  @Input() placeholder : any;
  @Output() selectionChange = new EventEmitter<number[]>();
  @ViewChild('auto') auto!: MatAutocomplete;

  searchControl = new FormControl('');
  filteredOptions: Option[] = [];
  selectedItems: any[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.filteredOptions = [...this.options];
    this.selectedItems = [...this.options.filter(opt => opt.isChecked)];
    this.searchControl.valueChanges.subscribe((value: any) => {this.filterOptions(value);});
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.filteredOptions = [...this.options]; 
      this.cdr.detectChanges();
    }, 0); // Ensures it runs after the first change detection cycle
  }

  filterOptions(value: any) {
    if (value !== null) {
      this.filteredOptions = this.options.filter(option =>
        option.name.toLowerCase().includes(value.toLowerCase())
      );
      this.cdr.detectChanges();
    }
  }

  toggleSelection(option: Option, event: MouseEvent | any): void {
    if (!this.multiSelect) {
      this.selectedItems = [option];
    } else {
      option.isChecked = !option.isChecked;

      if (option.isChecked) {
        this.selectedItems.push(option);
      } else {
        this.selectedItems = this.selectedItems.filter(item => item.id !== option.id);
      }
    }
    this.emitSelection();
  }

  handleSelection(event: any) {
    this.selectedItems = this.multiSelect ? event.value : [event.value];
    this.emitSelection();
  }

  getSelectedText(): string {
    return this.selectedItems.map(item => item.name).join(', ');
  }

  emitSelection() {
    this.selectionChange.emit(this.selectedItems.map(item => item.id));
  }

  trackById(index: number, item: Option) {
    return item.id;
  }


}
